export const getLocation = () => {
  return new Promise(function(resolve, reject) {
    try {
      const map = new BMapGL.Map("hll-container");
      const point = new BMapGL.Point(39.916527, 116.397128);
      map.centerAndZoom(point, 15);
      const geolocation = new BMapGL.Geolocation();
      geolocation.getCurrentPosition(location => {
        resolve(location);
      });
    } catch (err) {
      reject(err);
    }
  });
};
